<template>
    <!-- Footer -->
    <footer class="m-auto pt-3 mutua_footer">
            <div class="container footer">
              <div class="row p-0 g-0 justify-content-between">
                <div class="col-12 col-md-5 col-lg-4 py-3">
                  <div class="sideA">
                    <div class="link"><a target="_blank" rel="noreferrer" :href="`${downloadPath}${download_file}`" class="text-decoration-underline">{{ $t('footer.descarga') }}</a></div>
                    <div class="link"><a href="https://www.mutuauniversal.net/export/sites/webpublica/.content/docs/Junta/Informe-de-Gobierno-Corporativo-2021.pdf" target="_blank" rel="noreferrer" class="text-decoration-underline">{{ $t('footer.informe') }}</a></div>
                    <div class="link"><a target="_blank" rel="noreferrer" href="https://www.mutuauniversal.net/es/sobre-mutua-universal/organizacion-y-gobierno/memoria-e-informe-anual/" class="text-decoration-underline">{{ $t('footer.memorias_anteriores') }}</a></div>
                    <div class="socialMedia mt-3 align-items-start">{{ $t('footer.sigenos') }}
                        <div class="images-container mt-2">
                            <a class="mx-1 fbIcon" target="_blank" rel="noreferrer" href="https://www.facebook.com/MutuaUniversal/">
                                <img :src="`${publicPath}img/facebook.svg`" class="img-responsive whiteIcon">
                            </a>
                            <a class="mx-1" target="_blank" rel="noreferrer" href="https://twitter.com/mutuauniversal/">
                                <img :src="`${publicPath}img/twitter.svg`"  class="img-responsive whiteIcon">
                            </a>
                            <a class="mx-1" target="_blank" rel="noreferrer" href="https://www.instagram.com/mutuauniversal/">
                                <img :src="`${publicPath}img/instagram.svg`" class="img-responsive whiteIcon">
                            </a>
                            <a class="mx-1" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/mutua-universal/">
                                <img :src="`${publicPath}img/linkedin.svg`"  class="img-responsive whiteIcon">
                            </a>
                            <a class="mx-1" target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UCOabeoaD3lY1b-x5QWvdVtg">
                                <img :src="`${publicPath}img/youtube.svg`"  class="img-responsive whiteIcon">
                            </a>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-5 col-lg-4 py-3">
                  <div class="sideB">
                    <h6>{{ $t('footer.opinion') }}</h6>
                    <div class="description">{{ $t('footer.esta') }}</div>
                    <div class="opinion mt-3 mb-3 mb-lg-0">
                      <a target="_blank" href="https://memorias.mutuauniversal.net/formulario-opinion/index.html" class="text-decoration-underline">{{ $t('footer.quiero') }}</a></div>
                  </div>
                </div>
            </div>
        </div>
        <div class="postFooter">
            <div class="container row px-0 py-3 m-0 m-auto">
                <div class="col-8 col-lg-2 text-start m-auto">
                    <localized-link to="/">
                        <img :src="`${publicPath}img/logoMutua.gif`" class="img-responsive">
                    </localized-link>
                </div>
                <div class="col-12 col-lg-10 text-end pb-3">
                    <div class="row p-0 m-0 justify-content-end">
                        <div class="col-12 col-lg-auto mt-3 mt-lg-0 text-center text-lg-end">
                            <span class="me-3">&copy; MUTUA UNIVERSAL. 2021</span>
                        </div>
                        <div class="col-12 col-lg-auto text-center text-lg-end">
                            <a href="https://www.mutuauniversal.net/es/aviso-legal/" class="mx-1 mx-lg-3 text-decoration-underline" target="_blank">{{ $t('footer.aviso') }}</a>
                        </div>
                        <div class="col-12 col-lg-auto text-center text-lg-end">
                            <a href="https://www.mutuauniversal.net/es/politica-de-proteccion-de-datos/index.html" class="ms-1 ms-lg-3 text-decoration-underline" target="_blank">{{ $t('footer.politica') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- Footer -->
</template>

<script>
    export default {
        name: "FooterView",
        data () {
            return {
                publicPath: process.env.BASE_URL,
                isEs:true,
                isEn: false,
                locale: this.$i18n.locale,
                downloadPath: process.env.BASE_URL+"downloads/",
                download_file:'MU_memoria_2021_es.pdf',
            }
        },
      created() {
        // Remove show class from collapsible element to close movile menu
        this.$router.afterEach(() => {
          this.locale = this.$i18n.locale;


          switch (this.$i18n.locale) {
            case 'es':
              this.download_file='MU_memoria_2021_es.pdf';
              break;
            case 'ca':
              this.download_file='MU_memoria_2021_ca.pdf';
              break;
            case 'en':
              this.download_file='MU_memoria_2021_es.pdf';
              break;
            case 'ga':
              this.download_file='MU_memoria_2021_es.pdf';
              break;
            case 'eu':
              this.download_file='MU_memoria_2021_es.pdf';
              break;
            default:
              console.log('default');
          }

        });
      },
    };
</script>
